import React, { useEffect, useState } from 'react'
import { Button, Col, Container, FormGroup, Input, Label, Row, Spinner } from 'reactstrap'
import LoginImg from '../../Assets/images/login.jpg'
import Logo from '../../Assets/images/logo.png'
import OtpInput from 'react-otp-input';
import { toast } from 'react-toastify';
import Handler from '../../Helpers/Handler';
import { useDispatch, useSelector } from 'react-redux';
import { loadingFalse, loadingTrue } from '../../Reducer/loaderSlice';
import { setCookie } from '../../Helpers/Utils';
import { useAuth } from '../../Context/AuthenticateProvider';

const Login = () => {
  const dispatch = useDispatch();
  const { setIsAuthenticated } = useAuth();
  const loading = useSelector((state) => state?.loading?.loading);

  const [data, setData] = useState({});
  const [otpSection, setOtpSec] = useState(false);
  const [otp, setOtp] = useState("");

  const handleChange = (e) => {
    setData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const sendOtp = async () => {
    if (!data?.name || data.name.length < 3) {
      toast.error("Invalid Name");
      return;
    }
    if (!data?.email || !data.email.includes("@")) {
      toast.error("Invalid Email Address");
      return;
    }
    if (!data?.mobile || data.mobile.length !== 10) {
      toast.error("Invalid Mobile Number");
      return;
    }
    dispatch(loadingTrue());
    const response = await Handler({
      method: "post",
      url: `/auth/request_otp.php`,
      data: {
        name: data?.name,
        email: data?.email,
        mobile: data?.mobile
      }
    });

    if (response?.success) {
      dispatch(loadingFalse());
      toast.success("OTP Sent Successfully");
      setTimeout(() => {
        setOtpSec(true);
      }, 800);
    } else {
      dispatch(loadingFalse());
      toast.error(response?.message || "Something went wrong");
    }
  };

  const submitOtp = async () => {
    if (!otp || otp.length !== 6) {
      toast.error("Invalid OTP");
      return;
    }

    dispatch(loadingTrue());
    const response = await Handler({
      method: "post",
      url: `/auth/verify_otp.php`,
      data: {
        name: data?.name,
        email: data?.email,
        mobile: data?.mobile,
        otp: otp
      }
    });

    if (response?.success) {
      toast.success("Verified Successfully");
      dispatch(loadingFalse());
      setCookie('token', response?.token);
      setTimeout(() => {
        setIsAuthenticated(true);
      }, 800);
    } else {
      dispatch(loadingFalse());
      toast.error(response?.message || "OTP Verification Failed");
    }
  };

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      otpSection ? submitOtp() : sendOtp();
    }
  };

  useEffect(() => {
    dispatch(loadingFalse());
  }, []);

  return (
    <React.Fragment>
      {/* Responsive CSS - Form-aiye maathama logic-ai mattum fix panniruken */}
      <style>{`
        .login-bg { min-height: 100vh; padding: 20px 0; }
        .login-wrapper { border-radius: 12px; overflow: hidden; background: #fff; box-shadow: 0 5px 15px rgba(0,0,0,0.1); }
        .login-right { padding: 40px; }
        
        /* 320px Support - OTP Box & Spacing */
        @media (max-width: 576px) {
          .login-left { display: none; } /* Mobile-la image thookurathu professional-ah irukkum */
          .login-right { padding: 25px 15px; }
          .otp-container { gap: 5px !important; justify-content: space-between !important; }
          .otp-input { 
            width: 100% !important; 
            max-width: 40px !important; 
            height: 45px !important; 
            margin: 0 !important; 
          }
        }
      `}</style>

      <div className='d-flex align-items-center login-bg'>
        <Container>
          <Row className='justify-content-center'>
            <Col xs={12} md={10} lg={10}>
              <Row className='login-wrapper align-items-center mx-0'>
                <Col xs={12} md={6} lg={6} className='p-0 d-none d-md-block'>
                  <div className='login-left'>
                    <img src={LoginImg} alt='login-img' className='w-100' />
                  </div>
                </Col>

                <Col xs={12} md={6} lg={6} className='p-0'>
                  <div className='login-right d-flex flex-column h-100'>
                    <img className='company-logo mb-3' src={Logo} alt='logo' />
                    <h3 className='mb-2 fw-bold'>Sign in</h3>
                    <h6 className='mb-4 text-muted'>Welcome to Bizcarto Admin</h6>
                    
                    {otpSection && <h6 className='mb-4 sent-number text-info'>OTP Sent to: {data?.email}</h6>}
                    
                    {!otpSection ? (
                      <>
                        <FormGroup>
                          <Label for="name">Full Name</Label>
                          <Input
                            disabled={loading}
                            id="name"
                            name="name"
                            onKeyUp={handleKeyUp}
                            onChange={handleChange}
                            autoComplete='off'
                            value={data?.name || ""}
                            placeholder="Enter Name"
                            type="text"
                          />
                        </FormGroup>

                        <FormGroup>
                          <Label for="email">Email Address</Label>
                          <Input
                            disabled={loading}
                            id="email"
                            name="email"
                            autoComplete='off'
                            onKeyUp={handleKeyUp}
                            onChange={handleChange}
                            value={data?.email || ""}
                            placeholder="Enter Email"
                            type="email"
                          />
                        </FormGroup>

                        <FormGroup className='mb-4'>
                          <Label for="mobile">Mobile Number</Label>
                          <Input
                            disabled={loading}
                            id="mobile"
                            name="mobile"
                            autoComplete='off'
                            value={data?.mobile || ""}
                            onKeyUp={handleKeyUp}
                            onChange={(e) => {
                              if (/^\d{0,10}$/.test(e.target.value)) {
                                handleChange(e);
                              }
                            }}
                            placeholder="Enter Mobile Number"
                            maxLength={10}
                            type="text"
                          />
                        </FormGroup>
                      </>
                    ) : (
                      <>
                        <FormGroup className="mb-4">
                          <Label className="d-block mb-3 text-center text-md-start">Enter OTP</Label>
                          <OtpInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            renderInput={(props) => (
                              <input {...props} onKeyUp={handleKeyUp} className="otp-input-field" />
                            )}
                            containerStyle="otp-container d-flex"
                            inputStyle={{
                              width: "45px",
                              height: "45px",
                              margin: "0 5px",
                              fontSize: "18px",
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                              outline: "none",
                              textAlign: "center"
                            }}
                          />
                        </FormGroup>

                        <div className='d-flex justify-content-between mb-4 px-1' style={{fontSize: '14px'}}>
                          <p className="mb-0">Edit Details? <span className='text-primary fw-bold' style={{cursor: 'pointer'}} onClick={() => setOtpSec(false)}>Back</span></p>
                        </div>
                      </>
                    )}

                    <Button
                      disabled={loading}
                      onClick={otpSection ? submitOtp : sendOtp}
                      className='w-100 submit-btn login-btn py-2 fw-bold btn-primary'
                    >
                      {loading ? (
                        <div className='d-flex align-items-center justify-content-center'>
                          <Spinner size="sm" className='me-2'> Loading...</Spinner>
                          <span>Processing...</span>
                        </div>
                      ) : (
                        otpSection ? "Verify OTP" : "Send OTP"
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login;